import { useContext, useState } from 'preact/hooks';
import { SessionContext } from '../app.jsx';
import { post } from '../api.js';
import { Field, useForm } from '../ui/Field.jsx';
import { Entry } from './Login.jsx';

const EMPTY = { current: '', next: '', again: '' };

export function NewPassword({ forced = false }) {
  const { refresh, signOut } = useContext(SessionContext);
  const [f, bind, setF] = useForm(EMPTY);
  const [mismatch, setMismatch] = useState(false);
  const [error, setError] = useState(null);
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    setDone(false);
    setMismatch(f.next !== f.again);
    if (f.next !== f.again) return;
    setBusy(true);
    try {
      await post('/password', { current: f.current, next: f.next });
      if (forced) return await refresh();
      setF(EMPTY);
      setDone(true);
    } catch (err) {
      setError(err.message);
    }
    setBusy(false);
  };

  const form = (
    <form class="stack-form" onSubmit={submit}>
      <h1>Nova lozinka</h1>
      {forced && <p>Prvo postavi svoju lozinku. Privremenu više nećeš koristiti.</p>}
      {!forced && (
        <Field label="Trenutna lozinka">
          <input {...bind('current')} type="password" autocomplete="current-password" required />
        </Field>
      )}
      <Field label="Nova lozinka"><input {...bind('next')} type="password" autocomplete="new-password" required /></Field>
      <Field label="Ponovi novu lozinku" error={mismatch && 'Lozinke se ne poklapaju.'}>
        <input {...bind('again')} type="password" autocomplete="new-password" required />
      </Field>
      {error && <p class="alert" role="alert">{error}</p>}
      {done && <p class="notice" role="status">Lozinka je promenjena.</p>}
      <button class="btn" disabled={busy}>Sačuvaj lozinku</button>
      {forced && <button type="button" class="btn-link" onClick={signOut}>Izađi</button>}
    </form>
  );
  return forced ? <Entry>{form}</Entry> : form;
}
